












import Vue from 'vue';
import BoxContainer from "@/components/BoxContainer.vue";
import {ExtensionLogViewModel} from "@/models/ExtensionLogViewModel";

export default Vue.extend( {
  name: "ExtensionLogDetailsPanel" ,
  components: {
    BoxContainer
  },
  props: {
    extensionId: {
      type: Number
    }
  },
  data(): {
    extensionLogs: ExtensionLogViewModel[];
  }{
    return {
      extensionLogs: []
    }
  },
  methods: {
    async loadData() {

      let result = await this.axios.get('/ExtensionLogs/GetListForExtension' , { params: { extensionId: this.extensionId }});
      this.extensionLogs = result.data;
    },
  },
  mounted: async function() {
    await this.loadData();
  },
} )

